import { useSyncExternalStore } from 'react'

// Registers the service worker in the built app (not during development, where it would cache stale code).
export function registerServiceWorker() {
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // The app works without it, just not offline.
    })
  }
}

// Everything kept on this device for offline use. Called on sign-in and sign-out, so a shared phone never shows
// one person's family to the next.
export async function forgetOfflineCopies() {
  if (!('caches' in window)) return
  const keys = await caches.keys()
  await Promise.all(keys.filter((key) => key.startsWith('gatheredfrom-')).map((key) => caches.delete(key)))
}

const subscribe = (onChange: () => void) => {
  window.addEventListener('online', onChange)
  window.addEventListener('offline', onChange)
  return () => {
    window.removeEventListener('online', onChange)
    window.removeEventListener('offline', onChange)
  }
}

export const useOnline = () =>
  useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  )
